import { render, staticRenderFns } from "./MatchingProfile.vue?vue&type=template&id=338cb70f&"
import script from "./MatchingProfile.vue?vue&type=script&lang=js&"
export * from "./MatchingProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports